//TODO Redirected from `components` package. All the imports must be replaced with the package one and this file deleted.
import { LoadingSpinner } from '@gettactic/components/src/loadings/LoadingSpinner/LoadingSpinner';
export * from '@gettactic/components/src/loadings/LoadingSpinner/LoadingSpinner';
export default LoadingSpinner;
